import ProfileView from 'components/views/ProfileView';
import { connect } from 'react-redux';
import { getIsProfileLoaded } from 'store/profile';

const mapStateToProps = (state) => ({
	isLoading: !getIsProfileLoaded(state),
});

export default connect(mapStateToProps)(ProfileView as any);
